import { Counting } from './counting.model';

export class ImageCounts {
  countings: Counting[] = [];
}
